enum TargetType {
  CANDIDATE = 'CANDIDATE',
  COMMENT = 'COMMENT',
}

export default TargetType